import React, {useContext, useRef} from 'react';
import {Dimensions, StyleSheet, View} from 'react-native';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import PaymentComboIcon from 'src/components/img/svg/PaymentComboIcon';
import AVText from 'src/components/elements/AVText';
import {getTotalDisplayAmount, measureAndDispatchPositionY} from 'src/Util';
import AccountStore from 'src/stores/AccountStore';
import {useAppSelector} from 'src/redux/hooks';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import MainConsumerContext from 'src/components/MainConsumerContext';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import Util from 'src/Util';
import {getDescriber} from 'src/components/elements/home/descriptors/campusComponents/DescriptorType';
import {useGlobalize} from '../../../i18n/hook/useGlobalize';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Settings from 'src/Settings';
const {getCampusLocationStyles, paymentComboIconColor} = getDescriber();
import {setGreetingViewPosition} from 'src/redux/slices/tutorialLayoutSlice';

const width = Dimensions.get('window').width;

const GreetingsAndBalanceView = ({isTutorial = false}) => {
  const context = useContext(MainConsumerContext);
  const {displayBalances} = useAppSelector((state) => state.account.account);
  const {formatCurrency} = useGlobalize();

  const getTotalBalance = () => {
    const totalAmount = getTotalDisplayAmount(displayBalances);
    return formatCurrency(totalAmount, AccountStore.getCurrency(), {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  const greetingsViewRef = useRef(null);

  const getGreetingsViewPosition = () => {
    !isTutorial &&
      measureAndDispatchPositionY(greetingsViewRef, setGreetingViewPosition);
  };

  const onGreetingPress = () => {
    FirebaseAnalytic.trackEvent(
      '365PAY:onGreetingPress',
      'HomeScreen:GreetingsAndBalanceView',
    );
    context.actions.navigateToFunding(true, {
      transDate: Util.getCurrentDate(),
    });
  };
  return (
    <AVTouchableOpacity
      style={styles.touchable}
      accessibilityLabel={[
        Localized.Labels.formatString(
          Localized.Labels.hey_name,
          AccountStore.getFirstName(),
        ),
        Localized.Labels.balance + ': ' + getTotalBalance(),
      ].join('. ')}
      accessibilityHint="Double tap to navigate to the quick fund"
      accessibilityRole="button"
      testID={'qa_btn_QuickFund'}
      accessible
      onPress={onGreetingPress}
    >
      <View
        style={styles.container}
        ref={greetingsViewRef}
        onLayout={getGreetingsViewPosition}
      >
        <View style={styles.iconView}>
          <PaymentComboIcon color={paymentComboIconColor()} />
        </View>
        <View style={styles.textView}>
          <AVText
            style={[getCampusLocationStyles().greetNameText]}
            accessible={true}
            aria-label={`${AccountStore.getFirstName()}, text`}
            accessibilityLabel={AccountStore.getFirstName()}
            numberOfLines={1}
            adjustsFontSizeToFit={true}
            accessibilityRole="text"
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
          >
            {Localized.Labels.formatString(
              Localized.Labels.hey_name,
              AccountStore.getFirstName(),
            )}
          </AVText>
          <AVText
            style={[getCampusLocationStyles().balanceText]}
            adjustsFontSizeToFit={true}
            accessible={true}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
            accessibilityRole="text"
            accessibilityLabel={Localized.Labels.balance}
            numberOfLines={1}
            aria-label={`${Localized.Labels.balance}, text`}
          >
            {Localized.Labels.balance + ': ' + getTotalBalance()}
          </AVText>
        </View>
      </View>
    </AVTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    marginHorizontal: Styles.Spacing.m3,
    width: width - Styles.Spacing.m3 * 2,
    marginTop: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    padding: 16,
    marginBottom: Styles.Spacing.m3,
    ...getLayoutDescriber().shadowStyles().shadow,
  },
  iconView: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 60,
    width: 60,
    backgroundColor: Settings.isAramark()
      ? Styles.Colors.PayNew.neutralHuesBase12
      : Styles.blueHuesBase07,
    borderRadius: Styles.Spacing.m2,
  },
  arrowView: {
    right: Styles.Spacing.m3,
    position: 'absolute',
  },
  textView: {
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    marginLeft: 16,
    height: 60,
    width: width - Styles.Spacing.m6,
  },
  touchable: {minHeight: Styles.MinTouchableArea},
});

export default GreetingsAndBalanceView;
